"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BadgePrimitive = _interopRequireDefault(require("../primitives/BadgePrimitive"));
var _consts = require("./consts");
var _useTheme = _interopRequireDefault(require("../hooks/useTheme"));
const getTypeToken = ({
  name,
  theme,
  type
}) => {
  const tokens = {
    [_consts.TOKENS.background]: {
      [_consts.TYPE_OPTIONS.NEUTRAL]: theme.orbit.badgeNeutralBackground,
      [_consts.TYPE_OPTIONS.INFO_SUBTLE]: theme.orbit.badgeInfoSubtleBackground,
      [_consts.TYPE_OPTIONS.SUCCESS_SUBTLE]: theme.orbit.badgeSuccessSubtleBackground,
      [_consts.TYPE_OPTIONS.WARNING_SUBTLE]: theme.orbit.badgeWarningSubtleBackground,
      [_consts.TYPE_OPTIONS.CRITICAL_SUBTLE]: theme.orbit.badgeCriticalSubtleBackground,
      [_consts.TYPE_OPTIONS.DARK]: theme.orbit.badgeDarkBackground,
      [_consts.TYPE_OPTIONS.WHITE]: theme.orbit.badgeWhiteBackground,
      [_consts.TYPE_OPTIONS.INFO]: theme.orbit.badgeInfoBackground,
      [_consts.TYPE_OPTIONS.CRITICAL]: theme.orbit.badgeCriticalBackground,
      [_consts.TYPE_OPTIONS.SUCCESS]: theme.orbit.badgeSuccessBackground,
      [_consts.TYPE_OPTIONS.WARNING]: theme.orbit.badgeWarningBackground,
      [_consts.TYPE_OPTIONS.BUNDLE_BASIC]: theme.orbit.badgeBundleBasicBackground,
      [_consts.TYPE_OPTIONS.BUNDLE_MEDIUM]: theme.orbit.badgeBundleMediumBackground,
      [_consts.TYPE_OPTIONS.BUNDLE_TOP]: theme.orbit.badgeBundleTopBackground
    },
    [_consts.TOKENS.color]: {
      [_consts.TYPE_OPTIONS.NEUTRAL]: theme.orbit.badgeNeutralForeground,
      [_consts.TYPE_OPTIONS.INFO_SUBTLE]: theme.orbit.badgeInfoSubtleForeground,
      [_consts.TYPE_OPTIONS.SUCCESS_SUBTLE]: theme.orbit.badgeSuccessSubtleForeground,
      [_consts.TYPE_OPTIONS.WARNING_SUBTLE]: theme.orbit.badgeWarningSubtleForeground,
      [_consts.TYPE_OPTIONS.CRITICAL_SUBTLE]: theme.orbit.badgeCriticalSubtleForeground,
      [_consts.TYPE_OPTIONS.DARK]: theme.orbit.badgeDarkForeground,
      [_consts.TYPE_OPTIONS.WHITE]: theme.orbit.badgeWhiteForeground,
      [_consts.TYPE_OPTIONS.INFO]: theme.orbit.badgeInfoForeground,
      [_consts.TYPE_OPTIONS.CRITICAL]: theme.orbit.badgeCriticalForeground,
      [_consts.TYPE_OPTIONS.SUCCESS]: theme.orbit.badgeSuccessForeground,
      [_consts.TYPE_OPTIONS.WARNING]: theme.orbit.badgeWarningForeground,
      [_consts.TYPE_OPTIONS.BUNDLE_BASIC]: theme.orbit.badgeBundleBasicForeground,
      [_consts.TYPE_OPTIONS.BUNDLE_MEDIUM]: theme.orbit.badgeBundleMediumForeground,
      [_consts.TYPE_OPTIONS.BUNDLE_TOP]: theme.orbit.badgeBundleTopForeground
    }
  };
  return tokens[name][type];
};
const Badge = ({
  type = _consts.TYPE_OPTIONS.NEUTRAL,
  icon,
  children,
  ariaLabel,
  dataTest,
  id,
  carriers
}) => {
  const theme = (0, _useTheme.default)();
  return /*#__PURE__*/_react.default.createElement(_BadgePrimitive.default, {
    carriers: carriers,
    background: getTypeToken({
      name: _consts.TOKENS.background,
      theme,
      type
    }),
    foregroundColor: getTypeToken({
      name: _consts.TOKENS.color,
      theme,
      type
    }),
    icon: icon,
    id: id,
    ariaLabel: ariaLabel,
    dataTest: dataTest
  }, children);
};
var _default = Badge;
exports.default = _default;